import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hannah',
  templateUrl: './hannah.component.html',
  styleUrls: ['./hannah.component.scss']
})
export class HannahComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
